module.exports = __webpack_public_path__ + "img/logo-1.379981d8.svg";